/**
 * Raw numbers
 * If you need them formatted, use the phone number pipe
 */
export interface PhoneHours {
  salesMF: string | undefined;
  salesSat: string | undefined;
}

export const PHONE_NUMBERS = {
  sales: 8557170022,
  retention: 8555056600,
  customerSupport: 8552167674,
  claims: 8662042219,
};

export const PHONE_HOURS: PhoneHours = {
  salesMF: '7am - 6pm CT',
  salesSat: '8am - 4pm CT',
};

export const PHONE_HOURS_FORMATTED = {
  sales: 'Monday - Friday 7am to 6pm CT, Saturday 8am to 4pm CT',
};

export const PHONE_HOURS_CA: PhoneHours = {
  salesMF: '5am - 4pm PT',
  salesSat: '6am - 2pm PT',
};

export const PHONE_HOURS_FORMATTED_CA = {
  sales: 'Monday - Friday 5am to 4pm PT, Saturday 6am to 2pm PT',
};
